import type {ComponentProps, FC} from 'react';

import {cn} from '@/modules/foundation/shared/tailwind';

import type {ProductDescription} from './description';

type ProductDescriptionListProps = ComponentProps<'ul'> & {
	description?: ProductDescription | null;
};

const ProductDescriptionList: FC<ProductDescriptionListProps> = ({
	description,
	className,
	...rest
}) => {
	if (!description) {
		return null;
	}

	return (
		<ul className={cn('list-disc', className)} {...rest}>
			{description.map((descItem, idx) => {
				const title = descItem.title;
				const val = descItem.value;
				const isArray = Array.isArray(val);
				const isString = typeof val === 'string';

				return (
					<li key={idx} className="ml-3">
						<strong>{title}:</strong>{' '}
						{isString && <span className="opacity-75">{val}</span>}
						{isArray &&
							val.map(({title, value}, i) => {
								const isLast = i < val.length - 1;

								return (
									<span key={title} title={title} className="opacity-75">
										{value} {isLast && ' - '}
									</span>
								);
							})}
					</li>
				);
			})}
		</ul>
	);
};

export default ProductDescriptionList;
